import { StrictMode, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { useUiStore } from './store/ui.js';
import './styles/global.css';

// Propagate the Zustand theme value to documentElement. The inline
// script in index.html already painted the correct theme before
// React mounted; this keeps the attribute in sync after the persist
// middleware rehydrates (pointage:ui) and on every subsequent change.
// Every CSS variable in tokens.css cascades from :root[data-theme=…].
function ThemeApplier() {
  const theme = useUiStore((s) => s.theme);
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);
  return null;
}

// Service worker : uniquement pour le push (aucun cache offline).
// L'enregistrement ne demande aucune permission — l'opt-in explicite
// se fait depuis le panneau de la cloche.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js').catch(() => {});
}

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('No #root element in index.html');

createRoot(rootEl).render(
  <StrictMode>
    <ThemeApplier />
    <App />
  </StrictMode>,
);
